import { deleteCookie } from 'cookies-next'
import { cookieKeys } from 'lib/consts/browserStorage'
import { getCurrentDomain } from 'lib/helpers/getCurrentDomain/getCurrentDomain'

type Options = Parameters<typeof deleteCookie>[1]

/**
 * Drops the session token cookie and nothing else. Deliberately free of the `signOut` mutation
 * `useDeleteTokenCookie` wraps it with, so the Apollo error link can call it while recovering from a
 * 401 — a `signOut` fired on a session the server already rejected only 401s again.
 */
export const deleteTokenCookie = (): void => {
  const options: Options = {}

  // Look at the implementation for the setTokenCookie for
  // details on the "domain" and "path" props
  if (process.env.REDIRECT_TO_BRAND) {
    options.domain = getCurrentDomain()
    options.path = '/'
  }

  // Both spellings: a cookie written with domain/path is a different cookie to the browser.
  deleteCookie(cookieKeys.token)
  deleteCookie(cookieKeys.token, options)
}
